module.exports = __webpack_public_path__ + "static/media/Bran Stark 3.a8a6b1a7.jpg";